'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var numberRange = require('./number-range.js');

const interpolate = (num, inputRange, outputRange) => {
    const [x1, x2] = inputRange;
    const [y1, y2] = outputRange;
    if (x1 > x2) {
        throw new Error('interpolate: inputRange[0] should not be superior to inputRange[1]');
    }
    if (!numberRange.isNumberInRange(num, { min: x1, max: x2 })) {
        throw new Error(`interpolate: input number {${num}} is not in range of {${x1}}-{${x2}}`);
    }
    return y1 + ((num - x1) / (x2 - x1)) * (y2 - y1);
};

exports.interpolate = interpolate;
//# sourceMappingURL=interpolate.js.map
